import React from 'react'
import { Alert } from '@mui/material'

const GenericLoadError = (props) => {
  const mergedProps = {
    children: 'We encountered a problem. Please try again later',
    ...props,
  }
  return <Alert sx={{ m: 3 }} severity='error' {...mergedProps} />
}

export default GenericLoadError
